import createApiClient from "./api";
import { downloadBlob } from "../utils/downloadUtils";

const api = createApiClient();

export const createDrawingFolder = async (projectId, folderData) => {
  const response = await api.post(
    `/projects/${projectId}/drawing-folders`,
    folderData,
    {
      headers: {},
    }
  );
  return response.data;
};

export const fetchDrawingFolders = async (
  projectId,
  page = 1,
  pageSize = 10,
  filters = {},
  sortField = null,
  sortOrder = undefined,
  parentId = null,
) => {
  const response = await api.get(`/projects/${projectId}/drawing-folders`, {
    params: {
      skip: (page - 1) * pageSize,
      limit: pageSize,
      filters: JSON.stringify(filters),
      sort_field: sortField || null,
      sort_order: sortOrder || undefined,
      parent_id: parentId || "root",
    },
    headers: {},
  });
  return response.data;
};

export const fetchDrawingFolder = async (projectId, drawingFolderId) => {
  const response = await api.get(
    `/projects/${projectId}/drawing-folders/${drawingFolderId}`,
    {
      headers: {},
    }
  );
  return response.data;
};

export const updateDrawingFolder = async (
  projectId,
  drawingFolderId,
  folderData
) => {
  const response = await api.put(
    `/projects/${projectId}/drawing-folders/${drawingFolderId}`,
    folderData,
    {
      headers: {},
    }
  );
  return response.data;
};

export const deleteDrawingFolder = async (projectId, drawingFolderId) => {
  const response = await api.delete(
    `/projects/${projectId}/drawing-folders/${drawingFolderId}`,
    { headers: {} }
  );
  return response.data;
};

export const moveDrawingFolder = async (projectId, drawingFolderId, parentId) => {
  const response = await api.patch(
    `/projects/${projectId}/drawing-folders/${drawingFolderId}/move`,
    { parent_id: parentId },
    { headers: {} }
  );
  return response.data;
};

export const downloadDrawingFolder = async (projectId, drawingFolderId, folderName = 'drawings', showLatestRevisionsOnly = true) => {
  const response = await api.get(
    `/projects/${projectId}/drawing-folders/${drawingFolderId}/download`,
    {
      params: {
        show_latest_revisions_only: showLatestRevisionsOnly,
      },
      responseType: 'blob',
      headers: {},
    }
  );
  // Clean folder name for filename (remove special characters)
  const cleanFolderName = folderName.replace(/[^a-z0-9]/gi, '_').toLowerCase();
  const filename = `${cleanFolderName}.zip`;
  downloadBlob(response.data, filename);
  return response.data;
};

export const mergeDrawingFolderPDFs = async (
  projectId,
  drawingFolderId,
  params = {}
) => {
  const response = await api.get(
    `/projects/${projectId}/drawing-folders/${drawingFolderId}/merge-pdf`,
    {
      params: {
        show_latest_revisions_only: params.show_latest_revisions_only !== undefined ? params.show_latest_revisions_only : true,
        filters: params.filters || null,
        sort_field: params.sort_field || null,
        sort_order: params.sort_order || 'asc',
      },
      responseType: 'blob',
      headers: {},
    }
  );
  // Clean folder name for filename (remove special characters)
  const folderName = params.folderName || 'drawings';
  const cleanFolderName = folderName.replace(/[^a-z0-9]/gi, '_').toLowerCase();
  const timestamp = new Date().toISOString().split('T')[0];
  const filename = `${cleanFolderName}_merged_${timestamp}.pdf`;
  downloadBlob(response.data, filename);
  return response.data;
};

export const notifyProjectUsersAboutDrawingFolder = async (projectId, drawingFolderId, userIds = null, note = null) => {
  const requestBody = {};
  if (userIds && Array.isArray(userIds) && userIds.length > 0) {
    requestBody.user_ids = userIds;
  }
  if (note) {
    requestBody.note = note;
  }
  
  const response = await api.post(
    `/projects/${projectId}/drawing-folders/${drawingFolderId}/notify`,
    requestBody,
    {
      headers: {},
    }
  );
  return response.data;
};

export const fetchDrawingFolderShare = async (projectId, drawingFolderId) => {
  const response = await api.get(
    `/projects/${projectId}/drawing-folders/${drawingFolderId}/share`
  );
  return response.data;
};

export const shareDrawingFolder = async (projectId, drawingFolderId) => {
  const response = await api.post(
    `/projects/${projectId}/drawing-folders/${drawingFolderId}/share`
  );
  return response.data;
};

export const unshareDrawingFolder = async (projectId, drawingFolderId) => {
  const response = await api.delete(
    `/projects/${projectId}/drawing-folders/${drawingFolderId}/share`
  );
  return response.data;
};
